import React, { useContext, useEffect, useState } from "react";
import { supabase } from "../../supabaseClient";
import { AuthContext } from "../../AuthProvider";
import { Feed } from "../../types/api/Feed";
import { handleError } from "../../utils/handleError";
import { Link } from "react-router-dom";
import { ChevronRight } from "react-feather";
import { Layout } from "../../Layout";

type PartialFeed = Pick<Feed, "id" | "name" | "slug" | "auto_post_as">;

export function Feeds() {
  const { session } = useContext(AuthContext);
  const [feeds, setFeeds] = useState<PartialFeed[] | null>([]);

  useEffect(() => {
    getFeeds();
  }, [session]);

  const getFeeds = async () => {
    let { data: feeds, error } = await supabase
      .from("feeds")
      .select(
        "id, _id, name, slug, auto_publish, auto_post_as, webhook, instance_url, requirements"
      )
      .order("created_at");

    if (error) {
      handleError(error);
    }

    setFeeds(feeds as PartialFeed[]);
  };

  return (
    <Layout>
      <div className="container max-w-3xl py-14 mx-auto px-8">
        <div className="flex justify-between items-center mb-8 gap-4 max-lg:flex-col max-lg:items-start">
          <div className="prose">
            <h1>Social Media Feeds</h1>
          </div>
          <Link to="/feeds/new">
            <div className="btn btn-primary btn-lg">Add New Social Media</div>
          </Link>
        </div>

        <div className="grid gap-4">
          {feeds &&
            feeds.map((feed) => (
              <Link
                key={feed.id}
                to={`/feeds/${feed.id}`}
                className="card w-full bg-base-100 hover:bg-base-200 transition-colors"
              >
                <div className="card-body flex-row items-center justify-between">
                  <div>
                    <h2 className="card-title mb-2">{feed.name}</h2>
                    <p className="text-base-content/70">{feed.slug}</p>
                    {feed.auto_post_as && (
                      <p className="text-sm text-info mt-1">
                        Posts as: {feed.auto_post_as}
                      </p>
                    )}
                  </div>
                  <ChevronRight className="text-base-content/50" />
                </div>
              </Link>
            ))}
        </div>
      </div>
    </Layout>
  );
}
